
import { Component, Emit, Prop, Watch } from 'vue-property-decorator'
import FieldValidationMixin from "@/components/processing_steps/FieldValidationMixin.vue"
import FieldContainer from './FieldContainer.vue'

@Component({
  components: {
    FieldContainer
  }
})
export default class NewCurrencyField extends FieldValidationMixin {
  @Prop({ default: '' }) error!: string
  @Prop({ default: false }) required!: boolean
  @Prop({ default: '' }) maxValue!: string
  @Prop({ default: '' }) valueInCents!: string
  @Prop({ default: false }) isDisabled!: boolean
  @Prop({ default: null }) label!: string
  @Prop({ default: '' }) hintHtml!: string

  displayError = ''
  state: boolean | null = null
  inputValue = ''

  mounted() {
    this.inputValue = this.formatValue(this.valueInCents)
  }

  @Watch('error')
  onErrorChange () {
    this.displayError = this.error
    this.state = this.error ? false : null
  }

  @Emit('input')
  updateValue(event: InputEvent) {
    const input = event.target as HTMLInputElement
    const newValue = input.value

    // when more than 2 decimal places are entered, revert to previous value
    const regex = /^\d*(\.\d{0,2})?$/
    if (!regex.test(newValue) && newValue !== '') {
      input.value = this.inputValue
      return this.inputValue
    }

    if (isNaN(Number(newValue))) {
      this.state = false
      this.displayError = this.$gettext('Please enter a number!')
    } else if (this.maxValue && newValue > this.maxValue) {
      this.state = false
      this.displayError = this.$gettext('Please choose a lower number!')
    } else if (!this.requiredFieldIsEmpty(newValue, this.required) && newValue === '') {
      this.state = false
      this.displayError = this.$gettext('This field is required')
    }
    this.inputValue = newValue
    return Math.round(Number(newValue) * 100).toString()
  }

  formatValue(val: string) {
    if (val === '' || isNaN(Number(val))) {
      return val
    }
    const cents = Number(val)
    return (cents / 100).toFixed(2)
  }

  onBlur() {
    const num = Number(this.inputValue)
    if (!isNaN(num) && this.inputValue !== '') {
      this.inputValue = num.toFixed(2)
    }
  }
}
